import { takeLatest } from 'redux-saga/effects';
import { FieldSectionType } from 'api/field-sections/types';
import { createTaskRecord } from 'collections/tasks';
import { STATUS_FIELD_NAME } from 'data/fields/hooks/account-fields';
import { ACCOUNT_CONFIG_QUERY_KEY } from 'queries/account';
import { getProjectDependencyMapKey } from 'queries/common';
import { logger } from 'services';
import { invalidateTaskQuery } from 'utils/invalidate-task-query';
import { createSubTaskSagaAction } from '../actions';
function* createSubTaskSaga(action) {
    var _accountConfig_fields;
    const { payload } = action;
    const { projectId, taskId, queryClient, updateLocalState, ...rest } = payload;
    const accountConfig = queryClient.getQueryData(ACCOUNT_CONFIG_QUERY_KEY);
    const statusField = accountConfig === null || accountConfig === void 0 ? void 0 : (_accountConfig_fields = accountConfig.fields) === null || _accountConfig_fields === void 0 ? void 0 : _accountConfig_fields.find((f)=>f.fieldName === STATUS_FIELD_NAME && f.objectType === FieldSectionType.Task);
    if (!statusField) {
        return;
    }
    try {
        const task = yield createTaskRecord(projectId, rest);
        // This is done to optimistically update the local state for sub tasks list.
        if (updateLocalState) {
            updateLocalState(task);
        }
        yield invalidateTaskQuery(taskId);
        yield invalidateTaskQuery(rest.parentTask);
        yield queryClient.refetchQueries(getProjectDependencyMapKey(projectId));
    } catch (error) {
        logger.error('createSubTaskSaga failed', {
            error
        });
    }
}
export function* watchCreateSubTaskSaga() {
    yield takeLatest(createSubTaskSagaAction.type, createSubTaskSaga);
}
